export default {
    devices_bulk_unpairing_title: "Desvincular el dispositivo emparejado",
    devices_bulk_unpairing_serial: "Serial",
    devices_bulk_unpairing_unpair: "Desemparejar",
    devices_bulk_unpairing_the_device_is_already_added: "El dispositivo ya está añadido",
    devices_bulk_unpairing_devices_mush_have_other_linked_devices: "Los dispositivos deben tener otros dispositivos emparejados",
    devices_bulk_unpairing_device_not_found: "Dispositivo no encontrado",
    devices_bulk_unpairing_vidfleet_esn: "ESN de VidFleet",
    devices_bulk_unpairing_label: "Etiqueta",
    devices_bulk_unpairing_linked_to: "Emparejado a",
    devices_bulk_unpairing_the_device_has_been_unpaired: "El dispositivo se ha desacoplado",
    devices_bulk_unpairing_device_have_been_unpaired: "Los dispositivos se han desacoplado",
    devices_bulk_unpairing_unpairing_the_gps: "Desemparejar el dispositivo",
    devices_bulk_unpairing_single_device: "¿Estás seguro de que quieres desemparejar estos dispositivos?",
    devices_bulk_unpairing_transaction_message: "La solicitud para desemparejar los dispositivos se ha enviado correctamente, por favor revise la lista de transacciones para ver el estado de la solicitud.",
}